import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { TRANSACTIONS_ELIGIBLE_COUNT } from "src/api-setup/api-endpoints";

export const getEligibleTransactionCount = async (cookiesData, dispatch, timesheetKeys) => {
  if (!cookiesData || !timesheetKeys || timesheetKeys.length === 0) {
    return { count: 0, items: [], status: false, error: "Invalid parameters" };
  }
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_timesheet_mstr_key: timesheetKeys,
    };
    const response = await POSTAPI(false, TRANSACTIONS_ELIGIBLE_COUNT, null, apiHeaders, requestBody, dispatch);
    // On 200 the response interceptor returns the body directly; on error makeApi
    // returns the full axios response (body under `.data`, numeric `.status`).
    const body = typeof response?.status === "number" ? response?.data : response;
    return {
      count: body?.data?.count ?? 0,
      items: Array.isArray(body?.data?.items) ? body.data.items : [],
      status: body?.status === true,
      error: body?.errors?.msg || null,
    };
  } catch (error) {
    console.error("Error in getEligibleTransactionCount:", error);
    return { count: 0, items: [], status: false, error: error.message };
  }
};
